import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TextField from '@material-ui/core/TextField';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { PaymentLimitExceededRptActions } from "../../actions";
import { connect } from 'react-redux';
import tableRequest from '../../models/tableRequest.js';
import { Toast } from 'primereact/toast';
import { CSVLink } from "react-csv";
import Loader from '../../templates/Loader.js';
import moment from 'moment';

class PaymentLimitExceededRpt extends Component {
    constructor(props) {
        super(props);
        this.tblResponse = new tableRequest();
        this.onPage = this.onPage.bind(this);
        this.onSort = this.onSort.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.FilterData = this.FilterData.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.StatusTemplate = this.StatusTemplate.bind(this);
        this.TransactionDateTemplate = this.TransactionDateTemplate.bind(this);
        this.ApprovalTypeTemplate = this.ApprovalTypeTemplate.bind(this);
        this.approvalTypeFilter = this.approvalTypeFilter.bind(this);
        this.rowClassName = this.rowClassName.bind(this);
        this.state = {
            loading: false,
            FromDate: new Date(),
            ToDate: new Date(),
            first: 0,
            ApprovalTypeFilter: null,
            approvalTypeOptions: [
                { label: "All", value: "" },
                { label: "Auto", value: "Auto" },
                { label: "Admin", value: "Admin" }
            ],
            headers: [{
                key: "UniqueRequestNumber",
                label: "Request Number"
            }, {
                key: "MobileNo",
                label: "Mobile No"
            }, {
                key: "RedeemRequestId",
                label: "Redeem Request Id"
            }, {
                key: "PaymentMode",
                label: "Payment Mode"
            }, {
                key: "BeneficiaryName",
                label: "Beneficiary Name"
            }, {
                key: "Amount",
                label: "Amount"
            }, {
                key: "Status",
                label: "Status"
            }, {
                key: "TransactionDate",
                label: "Transaction Date"
            }],
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            sortOrder: '',
        }
    }

    componentDidMount() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() - 7);
        this.tblResponse.FromDate = date.toLocaleDateString();
        this.tblResponse.ToDate = new Date().toLocaleDateString();
        this.setState({
            FromDate: date,
            ToDate: new Date()
        });
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.exceededList !== this.props.exceededList) {
            if (this.props.exceededList) {
                var e = this.props.exceededList;
                this.setState({
                    totalRecords: e[0].TotalRows
                });
            }
        }
    }

    FilterData() {
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.props.exportingData(this.tblResponse);
        this.props.fetchApi(this.tblResponse);
    }

    handleChange(event) {
        const { name, value } = event.target;
        switch (name) {
            case 'FromDate':
                if (value === null || !(value instanceof Date)) {
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please select from date.', life: 3000 });
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please enter only date.', life: 3000 });
                    return;
                }
                else if ((value instanceof Date) && (this.state.ToDate instanceof Date)) {
                    const startDate = value;
                    const endDate = this.state.ToDate;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'From date must be less than to date.', life: 3000 });
                        return;
                    }
                }
                break;
            case 'ToDate':
                if (value === null || !(value instanceof Date)) {
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please select to date.', life: 3000 });
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'Please enter only date.', life: 3000 });
                    return;
                }
                else if ((value instanceof Date) && (this.state.FromDate instanceof Date)) {
                    const startDate = this.state.FromDate;
                    const endDate = value;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.toast.show({ severity: 'error', summary: 'Error Message', detail: 'To date must be greater than from date.', life: 3000 });
                        return;
                    }
                }
                break;
            default:
                break;
        }

        this.setState({ [name]: value });
    }

    //to lazy load
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows, first: event.first });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
    }

    onPage(event) {
        this.props.loadingData(true);
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.props.fetchApi(this.tblResponse);
            this.props.exportingData(this.tblResponse);
        }, 250);
    }

    //to search
    searchFilter(e) {
        this.tblResponse.SearchValue = e.target.value;
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }

    //to filter by approval type using the same internal search param
    approvalTypeFilter(e) {
        this.setState({ ApprovalTypeFilter: e.value });
        this.tblResponse.SearchValue = e.value || "";
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }

    //to sort
    onSort(event) {
        this.props.loadingData(true);
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.multiSortMeta[0].field === "TransactionDate" ? "TransactionDate" : event.multiSortMeta[0].field;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.props.fetchApi(this.tblResponse);
        this.props.exportingData(this.tblResponse);
    }

    //to highlight the transaction status
    StatusTemplate(rowData) {
        const status = rowData ? rowData.Status : "";
        const color = status && status.toLowerCase() === "success" ? '#2e7d32' : '#d32f2f';
        return (
            <span style={{ color: color, fontWeight: 'bold' }}>
                {status}
            </span>
        );
    }

    //to format the transaction date without the "T" separator
    TransactionDateTemplate(rowData) {
        return rowData && rowData.TransactionDate
            ? moment(rowData.TransactionDate).format('DD/MM/YYYY hh:mm A')
            : "";
    }

    //to label the approval type code
    ApprovalTypeTemplate(rowData) {
        const approvalTypeLabels = {
            1: "Admin",
            4: "Auto"
        };
        const approvalType = rowData ? rowData.ApprovalType : "";
        return approvalTypeLabels[approvalType] || approvalType;
    }

    //to highlight rows approved by Admin
    rowClassName(rowData) {
        const approvalType = rowData ? rowData.ApprovalType : "";
        const isAdmin = Number(approvalType) === 1 || String(approvalType).toLowerCase() === "admin";
        return { 'approval-admin-row': isAdmin };
    }

    render() {
        return (
            <div className="datatable-filter-demo">
                <Toast ref={(el) => this.toast = el} />
                <Loader loader={this.props.loading} />
                <div className="row mb-3">
                    <div className="col-md-3">
                        <h4>Payment Transaction Limit Exceeded Report</h4>
                    </div>
                    <div className="col-md-9">
                        <div className="row text-right">
                            <div className="col-md-2">
                                <Calendar placeholder="From Date" name="FromDate" showIcon="true" value={this.state.FromDate} onChange={this.handleChange}></Calendar>
                            </div>
                            <div className="col-md-2">
                                <Calendar placeholder="To Date" name="ToDate" showIcon="true" value={this.state.ToDate} onChange={this.handleChange}></Calendar>
                            </div>
                            <div className="col-md-2">
                                <Dropdown placeholder="Approval By" className="fullwidth" value={this.state.ApprovalTypeFilter} options={this.state.approvalTypeOptions} onChange={this.approvalTypeFilter}></Dropdown>
                            </div>
                            <div className="col-md-3 text-center ">
                                <button type="button" onClick={this.FilterData} className="btn btn-primary p-2 ml-3 buttone">Submit</button>
                                &nbsp;
                                <CSVLink data={this.props.List} headers={this.state.headers} filename={"Payment Limit Exceeded Report.csv"}
                                    target="_blank"><button className="btn btn-success p-2 mr-2 buttone">Export</button></CSVLink>
                            </div>
                            <div className="col-md-3">
                                <TextField id="standard-basic" size="small" variant="outlined" className="fullwidth" label="Search" onInput={this.searchFilter} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <DataTable value={this.props.exceededList}
                        scrollable responsive={true}
                        globalFilter={this.state.globalFilter}
                        emptyMessage="No Data found." sortMode="multiple" paginator={true}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={this.state.rows} style={{ width: '100%' }} rowsPerPageOptions={[5, 10, 20, parseInt(this.state.totalRecords)]}
                        totalRecords={parseInt(this.state.totalRecords)}
                        lazy={true} first={this.state.first}
                        rowClassName={this.rowClassName}
                        onPage={this.onPage} onSort={this.onSort} ref={(el) => { this.dt = el; }}>
                        <Column field="UniqueRequestNumber" header="Request Number" sortable></Column>
                        <Column field="BeneficiaryName" header="Beneficiary Name" sortable></Column>
                        <Column field="MobileNo" header="Mobile No" sortable></Column>
                        {/* <Column field="RedeemRequestId" header="Redeem Request Id" sortable></Column> */}
                        <Column field="PaymentMode" header="Payment Mode" sortable></Column>                        
                        <Column field="Amount" header="Amount" sortable></Column>
                        <Column field="Status" header="Status" body={this.StatusTemplate} sortable></Column>
                        <Column field="TransactionDate" header="Transaction Date" body={this.TransactionDateTemplate} sortable></Column>
                         <Column field="DeviceType" header="Device Type" sortable></Column> 
                       <Column field="ApprovalType" header="Approval By " body={this.ApprovalTypeTemplate} sortable></Column>
                    </DataTable>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        exceededList: state.PaymentLimitExceededRpt.items,
        List: state.PaymentLimitExceededRpt.exportitems == undefined ? [] : state.PaymentLimitExceededRpt.exportitems,
        loading: state.PaymentLimitExceededRpt.loading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchApi: (obj) => {
            dispatch(PaymentLimitExceededRptActions.getAll(obj))
        },
        loadingData: (isLoding) => dispatch(PaymentLimitExceededRptActions.loadingData(isLoding)),
        exportingData: (obj) => dispatch(PaymentLimitExceededRptActions.exportData(obj))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentLimitExceededRpt)
